export const exportXlsxEndpoint = '/api/conversations/export-xlsx';
export const exportFixedInstructionsEndpoint = '/api/customer-instructions/export-docx';
